import { render } from "./GoalCommentActivity.vue?vue&type=template&id=37dd3291"
import script from "./GoalCommentActivity.vue?vue&type=script&lang=js"
export * from "./GoalCommentActivity.vue?vue&type=script&lang=js"
script.render = render

export default script